import { connect } from 'react-redux';
import set from 'lodash/set';
import View from './MortgageView';
import {
  currentClientIdOrDefaultSelector,
  isInSummaryEditSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import {
  updateData,
  jump,
  updateValidation,
  depthFirstJump,
  save,
  updateSupportData,
} from '../../../AdvWorkflow/AdvWorkflowActions';
import { buildMutation } from '../../../AdvWorkflow/AdvWorkflowHelpers';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import {
  selectedMortgageOptionOrDefaultSelector,
  nullableMortgageTypeSelector,
  nullableMortgageInterestRateSelector,
  nullableMortgagePMISelector,
  mortgageTypeOptionsOrDefaultSelector,
} from './MortgageSelector';
import {
  previousIteratorsSelector,
  nullableHasPlanToGetMortgageSelector,
  alreadyHadMortgageSelector,
} from '../PlanToGetMortgage/PlanToGetMortgageSelector';
import { nullableMarketValueSelector } from '../../../HomePurchaseWorkflow/Steps/HomeEstimatedValue/HomeEstimatedValueSelector';
import nullableDownPaymentSelector from '../DownPayment/DownPaymentSelector';
import {
  nullableDesiredPurchaseYearSelector,
  nullablePurchaseAtRetirementSelector,
} from '../../../HomePurchaseWorkflow/Steps/YearHomePurchase/YearHomePurchaseSelector';

import nullableMonthlyHoaSelector from '../../../HomePurchaseWorkflow/Steps/HomeownersAssociationFee/HomeownersAssociationFeeSelector';
import nullableAnnualPropertyTaxSelector from '../../../HomePurchaseWorkflow/Steps/AnnualPropertyTax/AnnualPropertyTaxSelector';
import nullableAnnualHomeownersInsuranceSelector from '../../../HomePurchaseWorkflow/Steps/ExpectedAnnualHomeownerInsurance/ExpectedAnnualHomeownerInsuranceSelector';
import { nullablePropertyNameSelector } from '../../../HomePurchaseWorkflow/Steps/PropertyName/PropertyNameSelector';
import { nullableGoalIdSelector } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowSelector';

export const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientIdOrDefaultSelector(state, ownProps),
  alreadyHadMortgage: alreadyHadMortgageSelector(state, ownProps),
  hasPlanToGetMortgage: nullableHasPlanToGetMortgageSelector(state, ownProps),

  selectedMortgageOptionOrDefault: selectedMortgageOptionOrDefaultSelector(state, ownProps),
  mortgageTypeOptionsOrDefault: mortgageTypeOptionsOrDefaultSelector(state, ownProps),

  nullableMortgageInterestRate: nullableMortgageInterestRateSelector(state, ownProps),
  nullableMortgagePMI: nullableMortgagePMISelector(state, ownProps),

  nullableMortgageType: nullableMortgageTypeSelector(state, ownProps),

  marketValue: nullableMarketValueSelector(state, ownProps),
  desiredPurchaseYear: nullableDesiredPurchaseYearSelector(state, ownProps),
  purchaseAtRetirement: nullablePurchaseAtRetirementSelector(state, ownProps),
  downpayment: nullableDownPaymentSelector(state, ownProps),
  name: nullablePropertyNameSelector(state, ownProps),
  id: nullableGoalIdSelector(state, ownProps),

  nullableMonthlyHoa: nullableMonthlyHoaSelector(state, ownProps),
  nullablePropertyTax: nullableAnnualPropertyTaxSelector(state, ownProps),
  nullableHomeInsurancePerYear: nullableAnnualHomeownersInsuranceSelector(state, ownProps),

  isInSummaryEdit: isInSummaryEditSelector(state, ownProps),
  nextIterators: previousIteratorsSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  mortgageTypeChanged: workflowId => payload => {
    if (typeof payload !== 'undefined' && typeof payload !== 'object') {
      throw new Error('Invalid payload');
    }

    let MortgageType = null;
    if (payload) {
      MortgageType = payload.value;
    }

    dispatch(
      updateData(
        {
          [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
            MortgageType,
          },
        },
        workflowId,
      ),
    );
  },
  mortagageInterestRateChanged: workflowId => ({ target: { value } }) => {
    let InterestRate = null;
    if (value !== '') {
      InterestRate = value;
    }
    dispatch(
      updateData(
        {
          [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
            InterestRate,
          },
        },
        workflowId,
      ),
    );
  },
  mortgagePMIChanged: workflowId => ({ target: { value } }) => {
    let Pmi = null;
    if (value !== '') {
      Pmi = value;
    }
    dispatch(
      updateData(
        {
          [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
            Pmi,
          },
        },
        workflowId,
      ),
    );
  },
  onCancelled: (workflowId, marketValue, isInSummaryEdit, nextIterators) => () => {
    if (marketValue === null) {
      throw new Error('Market value must be set');
    }

    dispatch(
      updateData(
        {
          [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
            InterestRate: null,
            MortgageType: null,
            Pmi: null,
            DownPayment: marketValue,
          },
        },
        workflowId,
      ),
    );
    dispatch(
      updateSupportData(
        {
          [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
            HasPlanToGetMortgage: false,
          },
        },
        workflowId,
      ),
    );
    if (isInSummaryEdit) {
      dispatch(depthFirstJump(workflowId, nextIterators));
    } else {
      dispatch(jump(-1, workflowId));
    }
  },
  onSave: (
    workflowId,
    clientId,
    desiredPurchaseYear,
    purchaseAtRetirement,
    downpayment,
    marketValue,
    nullableMortgageType,
    nullableMortgageInterestRate,
    nullableMortgagePMI,
    nullableMonthlyHoa,
    nullablePropertyTax,
    nullableHomeInsurancePerYear,
    isInSummaryEdit,
    name,
    id,
  ) => () => {
    if (marketValue === null) {
      throw new Error('marketValue must be set');
    }

    if (downpayment === null) {
      throw new Error('downpayment must be set');
    }

    if (desiredPurchaseYear === null) {
      throw new Error('desiredPurchaseYear must be set');
    }

    if (purchaseAtRetirement === null) {
      throw new Error('purchaseAtRetirement must be set');
    }

    if (
      nullableMortgageType === null ||
      nullableMortgageInterestRate === null ||
      nullableMortgagePMI === null
    ) {
      return dispatch(
        updateValidation(
          set({}, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.Mortgage`, ['Please fill the missing fields']),
          workflowId,
        ),
      );
    }

    const goToNextViewNode = () => {
      dispatch(
        updateValidation(set({}, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.Mortgage`, []), workflowId),
      );
      if (isInSummaryEdit) {
        return dispatch(depthFirstJump(workflowId, []));
      }
      return dispatch(jump(1, workflowId));
    };

    return dispatch(
      save(
        HOME_PURCHASE_GOAL_GRAPH_NODE,
        goToNextViewNode,
        errors => {
          dispatch(
            updateValidation(
              buildMutation(`${HOME_PURCHASE_GOAL_GRAPH_NODE}.Mortgage`, errors),
              workflowId,
            ),
          );
        },
        workflowId,
        clientId,
        false,
        () => ({
          [HOME_PURCHASE_GOAL_GRAPH_NODE]: {
            MortgageType: nullableMortgageType,
            Pmi: nullableMortgagePMI,
            InterestRate: nullableMortgageInterestRate,
            DownPayment: downpayment,
            MarketValue: marketValue,
            DesiredPurchaseYear: desiredPurchaseYear,
            PurchaseAtRetirement: purchaseAtRetirement,
            MonthlyHoa: nullableMonthlyHoa,
            PropertyTax: nullablePropertyTax,
            HomeInsurancePerYear: nullableHomeInsurancePerYear,
            Name: name,
            Id: id,
          },
        }),
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
